"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getXHRPromise = function (xhr) {
    return new Promise(function (resolve, reject) {
        var onError = function (event) {
            xhr.removeEventListener('load', onError);
            reject(event.target);
        };
        var onLoad = function (event) {
            if (event.target.status === 200) {
                xhr.removeEventListener('load', onLoad);
                resolve(JSON.parse(event.target.responseText));
            }
            onError(event);
        };
        xhr.addEventListener('load', onLoad);
        xhr.addEventListener('error', onError);
    });
};
exports.get = function (url, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.withCredentials, withCredentials = _c === void 0 ? true : _c, _d = _b.headers, headers = _d === void 0 ? {} : _d;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.withCredentials = withCredentials;
    Object.keys(headers).forEach(function (key) {
        xhr.setRequestHeader(key, headers[key]);
    });
    var promise = getXHRPromise(xhr);
    xhr.send();
    return promise;
};
//# sourceMappingURL=xhr.js.map